export default "__VITE_ASSET__6b5a5bbc__"